import {useState} from 'react'
import {useSafeCallback} from '@freckle/react-hooks'
import {spanDangerous} from '@freckle/educator-entities/ts/common/models/html-text'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {PageWrapper} from '@freckle/school/ts/common/components/common/page-wrapper'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import type {TableParamsT} from '@freckle/school/ts/manage-teachers/components/api-controlled-table'
import type {TeacherTabFilteringT} from '@freckle/school/ts/manage-teachers/components/teacher-tab/'
import {RemoveSelfRosteredTeachersConfirmationWrapper} from '@freckle/school/ts/rostering/components/clean-up-roster/remove-self-rostered-teachers/self-rostered-teachers-removed-confirmation'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'
import {ReviewSelfRosteredTeachers} from './review-self-rostered-teachers'

type Props = {
  currentSchoolIds: Array<number>
  schools: Array<SchoolAttrs>
  tableParams: TableParamsT<TeacherTabFilteringT>
  schoolAdmin: SchoolAdminAttrs
}

export function RemoveSelfRosteredTeachersContainer(props: Props) {
  const {currentSchoolIds, schools, schoolAdmin} = props
  const [removedSelfRosteredTeachers, setRemovedSelfRosteredTeachers] = useState(0)
  const setRemovedSelfRosteredTeachersCB = useSafeCallback(() => setRemovedSelfRosteredTeachers, [])
  const [showConfirmation, setShowConfirmation] = useState(false)
  const {t} = useSafeTranslation()
  const breadcrumbsConfig = {
    currentItemName: spanDangerous(t('REMOVE_SELF_ROSTERED_REMOVE_SELF_ROSTERED_BREADCRUMB')),
    path: [
      {
        url: Routes.dashboard(),
        name: t('REMOVE_SELF_ROSTERED_DASHBOARD_BREADCRUMB'),
      },
      {
        url: Routes.rostering.cleanUpRosterLink(),
        name: t('REMOVE_SELF_ROSTERED_CLEAN_UP_BREADCRUMB'),
      },
    ],
    reactRouter: true,
  }
  const onRemoveAffiliationSuccess = useSafeCallback(() => () => setShowConfirmation(true), [])
  return (
    <>
      <PageWrapper
        title={t('REMOVE_SELF_ROSTERED_TEACHERS_TITLE')}
        breadcrumbsConfig={breadcrumbsConfig}
      >
        {showConfirmation ? (
          <RemoveSelfRosteredTeachersConfirmationWrapper
            schoolIds={currentSchoolIds}
            schools={schools}
            removedAffiliations={removedSelfRosteredTeachers}
            schoolAdmin={schoolAdmin}
          />
        ) : (
          <ReviewSelfRosteredTeachers
            {...props}
            setRemovedSelfRosteredTeachersCB={setRemovedSelfRosteredTeachersCB}
            onRemoveAffiliationSuccess={onRemoveAffiliationSuccess}
          />
        )}
      </PageWrapper>
    </>
  )
}
